import { fork } from 'redux-saga/effects';
//import watchUserAuthentication from './watchers';
import watch from './watchers';

export default function* startForman() {
  //yield fork(watchUserAuthentication);
  yield fork(watch);
}